import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { CardProps } from './Card';

export interface CardGroupProps {
  children: ReactElement<CardProps> | ReactElement<CardProps>[];
  className?: string;
  id?: string;
}

/**
 * The Card Group based on [The USWDS card component](https://designsystem.digital.gov/components/card/)
 *
 */
const CardGroup = ({ children, className, id }: CardGroupProps): JSX.Element => {
  return (
    <ul id={id} className={classNames(className, 'usa-card-group')}>
      {children}
    </ul>
  );
};

export default CardGroup;
